<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Gestion des retours">
          <div class="row row-inside mt-1">
            <div class="flex md3">
              <va-input
                :value="searchTerm"
                placeholder="Nom du partenaire, numéro..."
                removable
                @input="searchText"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>
            <div class="flex md2">
              <va-input
                :value="levelMin"
                label="Nombre minimum de retours actifs"
                placeholder="1"
                removable
                type="number"
                @input="nbRetourActifs"
              >
              </va-input>
            </div>
            <div class="flex md3">
              <va-button-toggle
                outline
                class="toggle-activite"
                v-model="showStatus"
                :options="optionsStatus"
              />
            </div>
            <div class="flex md2">
              <va-button
                class="fullwidth"
                :color="filterPrioritaire ? 'success' : 'danger'"
                @click="filterPrioritaire = !filterPrioritaire"
                >Traitement prioritaire</va-button
              >
            </div>
            <div class="flex md2">
              <va-button
                class="fullwidth"
                :color="filterByDateActive ? 'success' : 'danger'"
                @click="filterByDateActive = !filterByDateActive"
                >Entreprises inactives</va-button
              >
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md12 mb-4">
              <va-custom-table
                ref="vadatatable"
                class="va-table--hoverable va-table--stripped custom-table"
                :fields="fields"
                :data="filteredDataEntreprise"
                :no-data-label="$t('poissonnierTable.empty')"
                :per-page="parseInt(perPage)"
                detail-row-component="detail-row-retours"
                track-by="identreprise"
                @row-clicked="openEntreprise"
                clickable
              >
                <template slot="expend" slot-scope="props">
                  <div
                    v-if="
                      props.rowData.historique &&
                      props.rowData.historique.length > 0
                    "
                    class="flex md12 mx-0 px-0"
                    v-on:click="onCellClicked(props.rowData)"
                  >
                    <va-icon
                      :color="props.rowData.prioritaire ? 'success' : ''"
                      v-if="isVisible(props)"
                      size="20px"
                      name="fa fa-folder-open"
                    />
                    <va-icon
                      :color="props.rowData.prioritaire ? 'success' : ''"
                      v-else
                      size="20px"
                      name="fa fa-folder"
                    />
                  </div>
                </template>
                <template slot="status" slot-scope="props">
                  <div class="row row-inside">
                    <va-chip
                      class="fullwidth"
                      :color="statusColor(props.rowData)"
                      >{{ statusText(props.rowData) }}</va-chip
                    >
                  </div>
                </template>
                <template slot="actions" slot-scope="props">
                  <div
                    class="row row-inside px-2"
                    @click="preventDefaultAction"
                  >
                    <div class="flex md6">
                      <va-button
                        small
                        class="fullwidth"
                        color="info"
                        @click="openRetour(props.rowData.identreprise)"
                      >
                        <va-icon size="15px" name="fa fa-plus" />
                        <span>&nbsp retour</span></va-button
                      >
                    </div>
                    <div class="flex md6">
                      <va-button
                        small
                        class="fullwidth"
                        color="info"
                        @click="openAction(props.rowData.identreprise)"
                      >
                        <va-icon size="15px" name="fa fa-plus" />
                        <span>&nbspaction</span></va-button
                      >
                    </div>
                  </div>
                </template>
              </va-custom-table>
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md2 offset--md8">
              <va-button class="fullwidth" color="info" @click="openRetour()">
                <va-icon size="15px" name="fa fa-plus" />
                <span>&nbsp Ajouter un retour</span></va-button
              >
            </div>
            <div class="flex md2">
              <va-button class="fullwidth" color="info" @click="openAction()">
                <va-icon size="15px" name="fa fa-plus" />
                <span>&nbsp Ajouter une action</span></va-button
              >
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <manage-retour
      v-model="showRetour"
      :idretour="idSelectedRetour"
      :identreprise="idSelectedEntreprise"
      v-on:update="updateRetour"
      v-on:new="updateRetour"
    />
    <manage-action
      v-model="showAction"
      :idaction="idSelectedAction"
      :identreprise="idSelectedEntreprise"
      v-on:update="updateAction"
      v-on:new="updateAction"
    />
    <dashboard-fiche-entreprise
      v-model="showFicheEntreprise"
      :tableentreprise="tableentreprise"
      @update=""
    />
  </div>
</template>

<script>
import axios from "axios";
import ManageRetour from "./manageRetour";
import ManageAction from "./manageAction";
import vaCustomTable from "../journal/custom-table/VaDataTable";
// update process not from within the table?
import EventBus from "../../services/eventBus";
import { findIndex, orderBy, debounce, deburr } from "lodash";
import moment from "moment";
import { launchToast } from "../../services/utils";
import DashboardFicheEntreprise from "../dashboard/DashboardFicheEntreprise";

export default {
  name: "dashboard-retour",
  components: {
    ManageRetour,
    ManageAction,
    vaCustomTable,
    DashboardFicheEntreprise,
  },
  data() {
    return {
      //export within context
      perPage: 10,
      idSelectedRetour: null,
      idSelectedEntreprise: null,
      showRetour: false,
      idSelectedAction: null,
      idSelectedEntreprise: null,
      showAction: false,
      listeEntreprise: [],
      isaction: false,
      tableentreprise: "",
      showFicheEntreprise: false,
      filterByDateActive: false,
      optionsStatus: [
        { label: "Bloquées", value: "blocked" },
        { label: "Problèmes", value: "problem" },
        { label: "Toutes", value: "all" },
      ],
      showStatus: "all",
      searchTerm: null,
      levelMin: 0,
      filterPrioritaire: false,
    };
  },
  created() {
    this.updateListe();
  },
  mounted() {
    EventBus.$on("OPEN_ACTION_MODAL", (payload) => {
      this.openAction(payload.identreprise, payload.idaction_retour_entreprise);
    });
    EventBus.$on("OPEN_RETOUR_MODAL", (payload) => {
      this.openRetour(payload.identreprise, payload.idretour_entreprise);
    });
  },
  methods: {
    searchText: debounce(function (searchTerm) {
      this.searchTerm = searchTerm;
    }, 400),
    nbRetourActifs: debounce(function (levelMin) {
      this.levelMin = levelMin;
    }, 400),
    openEntreprise(entreprise) {
      if (this.isaction) {
        this.isaction = false;
        return;
      } else {
        this.showFicheEntreprise = true;
        this.tableentreprise = entreprise;
      }
    },
    async updateAction(action) {
      console.log(action);
      let i = findIndex(this.listeEntreprise, [
        "identreprise",
        action.identreprise,
      ]);

      let tmpEntreprise = this.listeEntreprise[i];

      // get new historique
      let tmpHistorique = await this.getHistorique(action.identreprise);

      if (tmpHistorique === -1) {
        this.launchToast("Erreur");
        return;
      }

      tmpEntreprise.definitif = tmpHistorique.definitif;
      tmpEntreprise.latest_action = tmpHistorique.latest_action;
      tmpEntreprise.latest_retour = tmpHistorique.latest_retour;
      tmpEntreprise.level = tmpHistorique.level;
      tmpEntreprise.historique = tmpHistorique.historique;

      //force update on deep change
      ///need to clean the data received
      this.$set(this.listeEntreprise, i, tmpEntreprise);
    },
    async updateRetour(retour) {
      console.log(retour);
      let i = findIndex(this.listeEntreprise, [
        "identreprise",
        retour.identreprise,
      ]);
      if (i < 0) {
        // get full list and select entreprise
        let listeFull = await this.getListe();
        let i = findIndex(listeFull, ["identreprise", retour.identreprise]);

        let tmpEntreprise = listeFull[i];

        this.listeEntreprise.push(tmpEntreprise);

        this.listeEntreprise = orderBy(this.listeEntreprise, ["nom"], ["desc"]);
      } else {
        let tmpEntreprise = this.listeEntreprise[i];

        // get new historique
        let tmpHistorique = await this.getHistorique(retour.identreprise);

        if (tmpHistorique === -1) {
          this.launchToast("Erreur");
          return;
        }
        tmpEntreprise.prioritaire = tmpHistorique.prioritaire;
        tmpEntreprise.definitif = tmpHistorique.definitif;
        tmpEntreprise.latest_action = tmpHistorique.latest_action;
        tmpEntreprise.latest_retour = tmpHistorique.latest_retour;
        tmpEntreprise.level = tmpHistorique.level;
        tmpEntreprise.historique = tmpHistorique.historique;

        //force update on deep change
        ///need to clean the data received
        this.$set(this.listeEntreprise, i, tmpEntreprise);
      }
    },

    preventDefaultAction() {
      this.isaction = true;
    },
    statusColor(item) {
      //retour definitif, sending is blocked
      if (item.definitif) {
        return "danger";
      }
      if (item.level === 0) {
        return "success";
      }
      if (item.level === 1) {
        return "info";
      }
      if (item.level === 2) {
        return "warning";
      }
      if (item.level >= 3) {
        return "danger";
      }
      return "gray";
    },
    statusText(item) {
      if (item.definitif) {
        return "Retour définitif";
      }
      if (item.level === 0) {
        return "Aucun retour actif";
      }
      if (item.level === 1) {
        return "1er retour";
      }
      if (item.level === 2) {
        return "2eme retour";
      }
      if (item.level === 3) {
        return "3eme retour - bloqué";
      }
      if (item.level >= 3) {
        return item.level + " retours - bloqué";
      }
      return "gray";
    },
    isVisible(props) {
      return this.$refs.vadatatable.isVisibleDetailRow(
        props.rowData.identreprise
      );
    },
    onCellClicked(data) {
      this.isaction = true;
      this.$refs.vadatatable.openRow(data.identreprise);
    },
    async updateListe() {
      this.listeEntreprise = await this.getListe();
    },
    async getListe() {
      try {
        let res = await axios.get("api/retours/liste-full");
        for (let ijk = 0; ijk < res.data.length; ijk++) {
          res.data[ijk].level_str = String(res.data[ijk].level);
          if (res.data[ijk].definitif) {
            res.data[ijk].level_str = "99";
          }
        }
        return res.data;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getHistorique(identreprise) {
      try {
        let res = await axios.get("api/retours/historique", {
          params: { identreprise: identreprise },
        });
        return res.data;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
        return -1;
      }
    },
    openRetour(identreprise, idretour) {
      this.idSelectedRetour = idretour ? idretour : null;
      this.idSelectedEntreprise = identreprise ? identreprise : null;
      this.showRetour = true;
    },
    openAction(identreprise, idaction) {
      this.idSelectedAction = idaction ? idaction : null;
      this.idSelectedEntreprise = identreprise ? identreprise : null;
      this.showAction = true;
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    filteredDataEntreprise() {
      let filteredData = this.listeEntreprise;

      //       optionsStatus: [
      //   { label: "Bloquées", value: "blocked" },
      //   { label: "Problèmes", value: "problem" },
      //   { label: "Toutes", value: "all" },
      // ],

      return filteredData.filter((item) => {
        let boolcond = true;

        if (
          this.showStatus === "blocked" &&
          item.level < 3 &&
          !item.definitif
        ) {
          boolcond = false;
        } else if (this.showStatus === "problem" && item.level === 0) {
          boolcond = false;
        }

        if (this.levelMin && item.level < this.levelMin) {
          boolcond = false;
        }

        if (
          item.closure_date &&
          moment(item.closure_date, "YYYY-MM-DD").isSameOrBefore(moment()) &&
          !this.filterByDateActive
        ) {
          boolcond = false;
        }
        if (this.filterPrioritaire) {
          boolcond = boolcond && item.prioritaire;
        }

        if (this.searchTerm && this.searchTerm.length >= 1) {
          let nomCpre = deburr(this.searchTerm).toLowerCase();
          testTmp = false;
          let testTmp =
            testTmp || deburr(item.nom).toLowerCase().includes(nomCpre);

          if (boolcond) {
            for (let ijk = 0; ijk < item.historique.length; ijk++) {
              testTmp =
                testTmp ||
                deburr(item.historique[ijk].numero)
                  .toLowerCase()
                  .includes(nomCpre);
            }
          }

          boolcond = boolcond && testTmp;
        }

        return boolcond;
      });
    },
    fields() {
      return [
        { name: "__slot:expend", width: "3%" },
        {
          name: "nom",
          title: "Société",
          sortField: "nom",
          width: "20%",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "level_str",
          width: "10%",
        },
        {
          name: "latest_retour",
          title: "Dernier retour",
          sortField: "latest_retour",
          width: "5%",
        },
        ,
        {
          name: "latest_action",
          title: "Derniere Action",
          sortField: "latest_action",
          width: "5%",
        },
        {
          name: "commentaire",
          title: "Derniere commentaire",
          sortField: "commentaire",
          width: "10%",
        },
        {
          name: "__slot:actions",
          width: "15%",
        },
        {
          name: "__slot:marge",
          width: "2%",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 95%;
}
</style>
